import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class ImagesAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getCarImages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => this.request('get', `${carId}/images.json?fields%5B%5D=imageIdentifier&fields%5B%5D=metadata&metadata=1&limit=0`)
        });
        // raw car images include the ones still in postprocessing
        Object.defineProperty(this, "getRawCarImages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => this.request('get', `${carId}/images.json?fields%5B%5D=imageIdentifier&fields%5B%5D=metadata&metadata=1&limit=0&cleaned=0`)
        });
        Object.defineProperty(this, "deleteImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId, imageId) => this.privateRequest('delete', `${carId}/images/${imageId}`)
        });
        Object.defineProperty(this, "updateImageCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId, imageId, imageCode) => {
                // Without this, image-generator silently skips FTP/CDN cache regen (ADV-144).
                const data = { image_code: imageCode, trigger_binary_updated: true };
                return this.privateRequest('post', `${carId}/images/${imageId}/metadata.json`, data);
            }
        });
        this.setConfig(config);
    }
}
export default new ImagesAPI({
    baseURL: config.imagesAPI.imgListUrl
});
